import isRedoEvent from './is-redo-event';
import isUndoEvent from './is-undo-event';

export default {
  isRedoEvent,
  isUndoEvent,
};
